module.exports = __webpack_public_path__ + "img/landing-01.44fe93c3.png";